export default "__VITE_ASSET__CdsPm2e8__"